<template>
   <info-box
      :title="'Expiration'"
      :exp_switch="true"
      :exp_on="exp_on"
      @expChange="handleSwitch"
   >
      <div class="exp-wrapper">

         <v-date-picker
            v-if="exp_on"
            class="exp-input"
            mode='single'
            popoverVisibility="focus"
            @input="updateExpDate"
            v-model="expDateDT">
            <input class="block-input exp-date-input"  :value='props.inputValue' :placeholder="'mm/dd/yyyy'" slot-scope='props'>
         </v-date-picker>

         <timepicker type="time" 
            v-if="exp_on"
            id="block_exp_time"
            :value="expDateDT"
            :small="false"
            @input="(e) => {expDateDT = e;}"></timepicker>
      </div>
   </info-box>
</template>

<script>

export default {
   data() {
      return {
         expDateDT: '',
         exp_on: this.on
      }
   },

   props: ['exp', 'on', 'recid'],

   created() {
      //updating on create so that we convert back to local time
      // if (this.on) {
      //    this.expDateDT = new Date(this.exp + " UTC");
      // } else {
      //    this.exp_on = false;
      //    this.expDateDT = '';
      // }
      this.convert();
   },

   methods: {
      updateExpDate() {
         this.$parent.$emit('changeExp', this.dateToString(this.expDateDT));
      },

      dateToString() {
         if (this.expDateDT instanceof Date) {
            let dateStr = this.expDateDT.toISOString().split(/[T, Z]+/);
            dateStr = dateStr[0] + ' ' + dateStr[1].substring(0, dateStr[1].indexOf('.'));
            return dateStr;
         } else {
            return this.expDateDT;
         }
      },

      handleSwitch(value) {
         this.exp_on = value;
         if (value) {
            if (this.exp == '' || this.exp == undefined) {
               this.expDateDT = new Date();
            } else {
               this.expDateDT = new Date(this.exp + " UTC");
            }
            this.updateExpDate();
         } else {
            this.expDateDT = '';
            this.updateExpDate();
         }
      },

      convert() {
         if (this.exp == undefined || this.exp == null || this.exp == '') {
            this.exp_on = false;
         } else {
            this.exp_on = true;
            this.expDateDT = new Date(this.exp + " UTC");
         }
      }
   },

   watch: {
      exp() {
         this.convert();
      },
      
      expDateDT() {
         this.updateExpDate();
      },
   }
}
</script>

<style lang="scss" scoped>
.exp-input {
   display: inline-block;

   &::after {
   content: '';
   position: absolute;
   right: 16px;
   top: 8px;
   bottom: 0;
   width: 16px;
   height: 16px;
   background-image: url('./../assets/img/schedule-calendar-graphic.svg');
   background-repeat: no-repeat;
   background-color: transparent;
   background-position: center center;
   background-size: cover;
   }
}

.exp-date-input {
   max-width: 140px;
   padding-left: 16px;
   position: relative;
   @include blocks-input; 
   background-color: #222c3c;
   color: #eff1f3;
}

#exp_checkbox {
   margin-right: 10px;
   margin-bottom: 10px;
}
.exp-wrapper {
   display: flex;
   align-items: flex-start;
}
#block_exp_time {
   margin-left: 10px;
}

</style>


